import React from "react";
import Layout from "../components/layout";
import SEO from "../components/seo";

var NotFoundPage = function NotFoundPage(_ref) {
  var _data$site, _data$site$siteMetada;

  var data = _ref.data,
      location = _ref.location;
  var siteTitle = (_data$site = data.site) === null || _data$site === void 0 ? void 0 : (_data$site$siteMetada = _data$site.siteMetadata) === null || _data$site$siteMetada === void 0 ? void 0 : _data$site$siteMetada.title;
  return /*#__PURE__*/React.createElement(Layout, {
    location: location,
    title: siteTitle
  }, /*#__PURE__*/React.createElement(SEO, {
    title: "404: Not Found"
  }), /*#__PURE__*/React.createElement("h1", null, "404: Not Found"), /*#__PURE__*/React.createElement("p", null, "You just hit a route that doesn't exist... the sadness."));
};

export default NotFoundPage;
export var pageQuery = "3159585216";